<script setup lang="ts">
import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { NXGRetailPosHeader, NXGRetailPosNavbar } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import { useHeaderStore } from '@/stores/header/headerStore'
import { useNavbarStore } from '@/stores/navbar/navbarStore'
import { useLastVisitedGame } from '@/composables/useLastVisitedGame/useLastVisitedGame'
import SSPageHeader from './SSPageHeader.vue'
import { useMainMenu } from '@/composables/useMainMenu/useMainMenu.ts'

const headerStore = useHeaderStore()
const { shouldShowNavbar } = storeToRefs(headerStore)
const { openMainMenu } = headerStore
const navbarStore = useNavbarStore()
const { activeMenuItemIndex } = storeToRefs(navbarStore)
const { setActiveMenuItem } = navbarStore
const router = useRouter()
const route = useRoute<'game'>()
const { setLastVisitedGame } = useLastVisitedGame()
const { gamesItems: menuItems } = useMainMenu()

const menuItemIndex = computed(() =>
  menuItems.value.findIndex(({ uuid }) => uuid === route.params.gameId),
)

watch(
  () => route.fullPath,
  () => {
    setActiveMenuItem(menuItemIndex.value)
  },
  { immediate: true },
)

const handleMenuItemClick = async (menuItemIndex: number, gameId: string, gameTitle: string) => {
  setActiveMenuItem(menuItemIndex)

  await router.push({
    name: 'game',
    params: {
      gameId,
    },
  })
  setLastVisitedGame(gameId, gameTitle)
}

const navigateToGame = (gameId: string) => {
  router.push({
    name: 'game',
    params: {
      gameId,
    },
  })
}

const { overlay = false } = defineProps<{
  overlay?: boolean
}>()
</script>

<template>
  <NXGRetailPosHeader class="ss-header" :overlay="overlay">
    <NXGRetailPosNavbar
      v-if="shouldShowNavbar"
      :menu-items="menuItems"
      :active-menu-item-index="activeMenuItemIndex"
      @toggle-menu-click="openMainMenu"
      @click-menu-item="handleMenuItemClick"
    />
    <SSPageHeader v-else @click-last-visited-game="navigateToGame" />
  </NXGRetailPosHeader>
</template>

<style lang="scss" scoped>
.ss-header {
  grid-area: header;
}
</style>
